import {AuditDamageValueBody, TConditionFormValue} from '../../../types/ConditionTypes';

export const isDamageValueArray = (
  value: TConditionFormValue | undefined
): value is AuditDamageValueBody[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'object' && item !== null);
